module.exports = __webpack_public_path__ + "img/cl-install-CW-5000-association.4b2d951f.png";